module.exports = __webpack_public_path__ + "home-block-3-image@2x-2-2_myT.jpg";